<script setup>
import { computed } from "vue";
import { cn } from "@/lib/utils";
import { buttonVariants } from "./buttonVariants";

const props = defineProps({
  variant: { type: String, default: 'default' },
  size: { type: String, default: 'default' },
  class: { type: String, default: '' },
  as: { type: String, default: 'button' },
});

const calculatedClass = computed(() => {
    return cn(buttonVariants({ variant: props.variant, size: props.size }), props.class)
});
</script>

<template>
  <component :is="as" :class="calculatedClass" v-bind="$attrs">
    <slot />
  </component>
</template>
